import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "formatLanguage",
  	pure: true
})
export class FormatLanguagePipe implements PipeTransform {
  	transform(value: any, args?: any): any {
    	return value ? `${value.name} (${value.code.toUpperCase()})` : "";
  	}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/pipes/format-language.pipe.ts